var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-message"},[_c('IconVera',{staticClass:"empty-message__icon"}),_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.textButton)?_c('button',{staticClass:"empty-message__button button",on:{"click":_vm.onSetInterests}},[_vm._v("\n        "+_vm._s(_vm.textButton)+"\n    ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }